import React from "react";
import Button from "../../../../components/UI/button/GgButton";
import { AddIcon } from "../../../../assets/icons";
import Input from "../../../../components/UI/input/GgInput";
import { useModal } from "../../../../customHooks/useModal";
import Modal from "../../../../components/modal/Modal";
import ImageLoader from "../../../../components/imageLoader/ImageLoader";
import {ILoanCBlock, IPMBlock } from "../../../../models/IPages";
import { $public } from "../../../../http";
import { getImageExtensionFromBase64 } from "../../../../utils";
import FileButton from "../../../../components/UI/button/FileButton";

function LoanCustomer({ data, setData, categoryType, actionData }: IPMBlock) {
  const LoanCustomerHandler = (val: string, type: keyof ILoanCBlock) =>
  setData((prev: any) => {
    if (type === "image") {
      const ext = getImageExtensionFromBase64(val);
      return {
        ...prev,
        [type]: `/image/page-management/${categoryType}/loanCustomerBlock1.${ext || "jpeg"
          }`,
        images: [val],
      };
    }
    return { ...prev, [type]: val };
  });

  return (
    <>
      <div className="title">Loan Cutsomter Block</div>
      <div className="step-list">
        <div className="step-item">
          <div className="inputs-container">
            <Input
              type="text"
              placeholder="Enter title"
              label="Title"
              value={data?.title}
              onChange={(val) => LoanCustomerHandler(val, 'title')}
              disabled={!actionData?.edit}
            />
          </div>
        </div>
        <div className="step-item">
          <div className="inputs-container">
            <Input
              type="text"
              placeholder="Enter Description"
              label="Description" 
              value={data?.description}
              onChange={(val) => LoanCustomerHandler(val, 'description')}
              disabled={!actionData?.edit}
            />
          </div>
        </div>
      </div>
      <div className="step-list col">
        <div className="step-item">
          <div>Background Banner</div>
          <FileButton
            index={"team-customerBLock"}
            icon={{
              leftIcon: <AddIcon size="18" className="icon" />,
            }}
            value={data?.image}
            stylesType="border"
            onChange={(val) => LoanCustomerHandler(val, "image")}
            className="cover-image-button"
            disabled={!actionData?.edit}
          />
        </div>
      </div>
    </>
  );
}

export default LoanCustomer;
